<script>
  import HubShare from './HubShare.vue'

  export default {
    props: ['piece', 'open'],

    components: {
      HubShare
    }
  }
</script>

<template>
  <div class="modal" v-if="open" :class="[piece.type, { 'is-active': open }]" >
    <div class="modal-background" @click="$emit('close')"></div>
    <div class="modal-content">

      <div class="content-image" v-if="!piece.video">
        <div class="figure">
          <figure class="image is-square">
            <img :src="piece.image" />
          </figure>
        </div>
        <div class="caption">
          <div class="meta">
            <div class="author">{{ piece.author }},</div>
            <div class="occupation">{{ piece.occupation }}</div>
          </div>
          <div class="content">
            <div v-html="piece.description"></div>
            <p style="margin-top: 1rem;" v-if="piece.url && piece.visit"><a target="_blank" :href="piece.url">{{ piece.visit }}</a></p>
          </div>
        </div>
      </div>

      <div v-else>
        <div class="content-video">
          <div class="figure">
            <div class="embed-container" v-html="piece.video"></div>
          </div>
          <div class="caption">
            <div class="meta">
              <div class="author">{{ piece.author }},</div>
              <div class="occupation">{{ piece.occupation }}</div>
            </div>
            <p v-if="piece.url && piece.visit"><a target="_blank" :href="piece.url">{{ piece.visit }}</a></p>
          </div>
        </div>
        <div class="video-description">
          <div class="content" v-html="piece.description"></div>
        </div>
      </div>

      <hub-share :piece="piece"></hub-share>
    </div>
    <button class="modal-close is-large" aria-label="close" @click="$emit('close')"></button>
  </div>
</template>

<style lang="scss" scoped>
  @import "../sass/variables";

  @each $type, $colour in $types {
    .#{$type} .modal-content {
      background: $colour;
    }
  }

  .modal-content {
    padding: 1rem;
    width: 80%;
    max-width: 960px;
  }

  .modal-content, .modal-content a {
    color: white;
  }

  .content-image {
    display: flex;
  }

  .content-image .figure {
    width: 50%;
    margin-right: 1rem;
  }

  .content-image .caption {
    width: 50%;
    max-width: 275px;
  }

  .content-video {
    display: flex;
    margin-bottom: 1rem;
  }

  .content-video .figure {
    width: 70%;
    margin-right: 1rem;
  }

  .content-video .caption {
    width: 20%;
  }

  .video-description {
    max-width: 80%;
  }

  .meta {
    font-family: "Separat";
    font-size: 2.25rem;
    text-transform: uppercase;
    line-height: 1em;
    margin-top: 1rem;
    margin-bottom: 1em;
  }

  .embed-container { position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden; max-width: 100%; }
  .embed-container /deep/ iframe { position: absolute; top: 0; left: 0; width: 100%; height: 100%; }
</style>



// WEBPACK FOOTER //
// partials/HubModal.vue